import { HOLDEM_MODULE_ID } from './Holdem';
import { PALLETS_MODULE_ID } from './Pallets';

/**
 * Activities that draw every participant's video themselves (#4815: Pallets seats each player's
 * camera at the card table beside their cards; Hold'em seats them around the poker table with
 * the AI opponents). While one is on stage the room hides its PIP dock — every participant tile
 * and the companion tile — and its Stage Grid, gives the activity the full-bleed stage, and keeps
 * remote participants' audio playing through audio-only sinks.
 *
 * One list for both sides of the broadcast: the room reads it to hide its dock, and signaling's
 * sixync bridge reads it to leave those same tiles out of the program layout the compositor
 * records, so the recording cannot show PIPs the room does not.
 */
export const ACTIVITY_OWNS_PARTICIPANT_TILES: ReadonlySet<string> = new Set([
  PALLETS_MODULE_ID,
  HOLDEM_MODULE_ID,
]);

export function activityOwnsParticipantTiles(moduleId: string | null | undefined): boolean {
  return !!moduleId && ACTIVITY_OWNS_PARTICIPANT_TILES.has(moduleId);
}
